import { useAuthStore } from '@/stores/useAuthStore'
import { getCurrentUserId, getUserRole, getUserName } from '@/utils/jwt'

/**
 * Hook to get the current user info from the access token
 */
export function useCurrentUser() {
  const accessToken = useAuthStore(state => state.accessToken)
  const role = getUserRole(accessToken)

  return {
    userId: getCurrentUserId(accessToken),
    role,
    name: getUserName(accessToken),
    isAdmin: role === 'ADMIN',
    isManager: role === 'MANAGER' || role === 'ADMIN',
  }
}
